// Application constants

export const VAT_RATE = 0.23; // 23%

export const DISCOUNT_OPTIONS = [
  { value: 0, label: "Retail" },
  { value: 10, label: "10%" },
  { value: 15, label: "15%" },
  { value: 20, label: "20%" },
  { value: 25, label: "25%" },
  { value: 30, label: "30%" },
  { value: 33, label: "33%" },
  { value: 35, label: "35%" },
  { value: 40, label: "40%" },
  { value: -1, label: "NETT" }
];

export const TRANSACTION_TYPES = {
  CASH_SALE: 'cash_sale',
  REFUND: 'refund',
  INVOICE: 'invoice',
  CREDIT_NOTE: 'credit_note',
  QUOTE: 'quote'
};

// Refund and Credit Note both credit money back rather than create a sale -
// their pages/forms share a warning colour so someone picking up a terminal
// that's already open on one of these can't mistake it for a Cash Sale/Invoice.
export const CREDIT_TRANSACTION_TYPES = [TRANSACTION_TYPES.REFUND, TRANSACTION_TYPES.CREDIT_NOTE];

export const MAX_LINE_ITEMS = 20;

// Stable per-row id generator, independent of array position, so React can
// track line-item row identity correctly across add/delete instead of
// relying on the array index as a key.
let nextLineItemRowId = 1;
export const createEmptyLineItem = () => ({
  _rowId: nextLineItemRowId++,
  registration: '',
  part_number: '',
  description: '',
  qty: 0,
  price: 0,
  discount: 0,
  vat_perc: 23,
  subtotal: 0,
  vat: 0,
  total: 0
});

export const AUTOCOMPLETE_MIN_CHARS = 2;
export const AUTOCOMPLETE_DEBOUNCE_MS = 300;
